/**
 * Created by ys on 2018/4/3.
 */
//import  router from './../../router'
import store from "../index";
import titleNameJson from "../../js/titleName.json";

let routers = localStorage.getItem("menuRouter");
let myMenuRouter = [];
if(routers != null && routers!= undefined && routers != ""){
  myMenuRouter = JSON.parse(routers);
}
document.title = localStorage.getItem("titleName") || "加载中...";
const user = {
  state: {
    certification:localStorage.getItem("certification"),
    userAccount:localStorage.getItem("userAccount"),
    userId:localStorage.getItem("userId"),
    name:localStorage.getItem("name"),
    userTypeName:localStorage.getItem("userTypeName"),
    photo:localStorage.getItem("photo"),
    mobile:localStorage.getItem("mobile"),
    agencyId:localStorage.getItem("agencyId"),
    agencyName:localStorage.getItem("agencyName"),
    isLeafAgency:localStorage.getItem("isLeafAgency"),

    manageKey:localStorage.getItem("manageKey"),
    mapLonLat: localStorage.getItem("mapLonLat"),
    // address:localStorage.getItem("address"),
    roleTypeList: localStorage.getItem("roleTypeList"),
    isUnitManageMan :localStorage.getItem("isUnitManageMan"),//是否单位管理员
    menuRouter:myMenuRouter,//界面路由
    titleName:localStorage.getItem("titleName"),//标题
    urlTitle:localStorage.getItem("urlTitle"),//浏览器url访问的标题,通过它来区分区域
    isEnterprise:localStorage.getItem("isEnterprise"),//机构/单位的判断，机构：0 单位：1

    isMaintainAgency:localStorage.getItem("isMaintainAgency"),//是否是维保单位，1是 0否

    division:localStorage.getItem("division"),//机构的行政划分  1.divisionId 2.divisionLeve 3.divisionName
    isOnlyManage:localStorage.getItem("isOnlyManage"),//只有系统管理功能的区分
    commonPermission:localStorage.getItem("commonPermission"),//通用权限
    agencyTypeId:localStorage.getItem("agencyTypeId"),//单位机构类型ID(1-消防监督机构;2-消防责任单位;3-消防维护机构;4-运营销售单位)
    grid:JSON.parse(localStorage.getItem("grid")),//网格信息
    resetPassword:localStorage.getItem("resetPassword"),// 是否需要重置密码
  },
  mutations: {
    SET_CERTIFICATION: (state, certification) => {
      state.certification = certification;
    },
    SET_USER_ACCOUNT:(state, userAccount)=>{
      state.userAccount = userAccount;
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId;
    },
    SET_USER_NAME: (state, name) => {
      state.name = name;
    },
    SET_USER_TYPE_NAME: (state, userTypeName) => {
      state.userTypeName = userTypeName;
    },
    SET_PHOTO: (state, photo) => {
      state.photo = photo;
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile;
    },
    SET_AGENCY_ID: (state, agencyId) => {
      state.agencyId = agencyId;
    },
    SET_AGENCY_NAME: (state, agencyName) => {
      state.agencyName = agencyName;
    },
    SET_IS_LEAF_AGENCY: (state, isLeafAgency) => {
      state.isLeafAgency = isLeafAgency;
    },

    SET_MANAGE_KEY: (state, manageKey) => {
      state.manageKey =  manageKey;
    },
    SET_MAP_LON_LAT: (state, mapLonLat) => {
      state.mapLonLat =  mapLonLat;
    },
    // SET_ADDRESS:(state, address) => {
    //   state.address =  address;
    // },
    SET_ROLE_TYPE_LIST: (state, roleTypeList) => {
      state.roleTypeList =  roleTypeList;
    },
    SET_IS_UNIT_MANAGE_MAN: (state, isUnitManageMan) => {
    state.isUnitManageMan =  isUnitManageMan;
    },
    SET_MENU_ROUTER: (state, menuRouter) => {
      state.menuRouter =  menuRouter;
    },
    SET_TITLE_NAME: (state, titleName) => {
      state.titleName =  titleName;
    },
    SET_URL_TITLE: (state, urlTitle) => {
      state.urlTitle =  urlTitle;
    },
    SET_IS_ENTERPRISE: (state, isEnterprise) => {
      state.isEnterprise =  isEnterprise;
    },
    SET_IS_MAINTAINAGENCY: (state, isMaintainAgency) => {
      state.isMaintainAgency =  isMaintainAgency;
    },
    SET_DIVISION: (state, division) => {
      state.division =  division;
    },
    SET_IS_ONLY_MANAGE: (state, isOnlyManage) => {
      state.isOnlyManage =  isOnlyManage;
    },
    SET_COMMON_PERMISSION:(state,commonPermission) => {
      state.commonPermission = commonPermission;
    },
    SET_AGENCY_TYPE_ID:(state,agencyTypeId) => {
      state.agencyTypeId = agencyTypeId;
    },
    SET_GRID:(state,grid) => {
      state.grid = grid;
    },
    SET_RESET_PASSWORD: (state, resetPassword) => {
      state.resetPassword =  resetPassword;
    },
  },
  actions: {
    // 获取用户信息
    GetInfo({commit}, ret) {
      var commonPermissionList = ret.user.permissionList;
      var commonPermission = [];
      for(var i=0;i<commonPermissionList.length;i++){
        if(3 == commonPermissionList[i].type){
          commonPermission.push(commonPermissionList[i].id);
        }
      }
      //注入通用权限
      localStorage.setItem("commonPermission",JSON.stringify(commonPermission));
      commit('SET_COMMON_PERMISSION', JSON.stringify(commonPermission));
      var manageKey = 0; //用于判断是否有系统管理
      var isOnlyManage = true;//只有系统管理功能的区分
      //获取路由信息
      let routes = [];
      //获取大屏界面的路由
      let isPro= ret.user.isEnterprise != '1' && ret.user.divisionLevel != undefined && ret.user.divisionLevel <= 1;//是否省级
      for(let i=0;i<ret.menuListPath.length;i++) {
        if (ret.menuListPath[i].id == 5010000 ||  ret.menuListPath[i].id == 5020000) {
          //大屏：支队不能有单位的权限，单位不能有支队的权限
          if((ret.menuListPath[i].id == 5020000 && ret.user.isEnterprise != 1)||( ret.menuListPath[i].id == 5010000 && ret.user.isEnterprise === 1)){
            continue;
          }
          let indexComponent = null;
          let props0 = getProps(ret.menuListPath[i].url);
          if(isPro){
            indexComponent = resolve => { require(['@/components/super/province-index.vue'], resolve) };
          }else if(ret.menuListPath[i].id == 5010000){
            indexComponent = resolve => { require(['@/components/super/index.vue'], resolve) };
          }else if(ret.menuListPath[i].id == 5020000){
            indexComponent = resolve => { require(['@/components/unit/index.vue'], resolve) };
          }
          routes.push(
            {
              title: ret.menuListPath[i].cnName,
              path: props0.url,
              name: ret.menuListPath[i].id,
              redirect: ret.menuListPath[i].id == 5010000 ? 'super/index': 'unit/index',
              component: resolve => { require(['@/components/unit.vue'], resolve) },
              type:props0.component,
              children: [
                {
                  title: '首页',
                  path: 'index',
                  name: '首页',
                  component: indexComponent,
                  type:isPro ?'province-index' : 'index',
                }
              ],
              meta: {
                id: ret.menuListPath[i].id,
                title: ret.menuListPath[i].cnName,
                local: ret.menuListPath[i].name,
              }
            }
          );
          for(let j=0;j<ret.menuListPath[i].List.length;j++){
            let props1 = getProps(ret.menuListPath[i].List[j].url);
            //打印权限
            // if(ret.menuListPath[i].id == 5010000){
            //   console.log(  ret.menuListPath[i].List[j].id + ":()=>import('@/components/super/"+ props1.component.replace('super/','') + ".vue'),");
            // }else{
            //   console.log(  ret.menuListPath[i].List[j].id + ":()=>import('@/components/unit/"+ props1.component.replace('unit/','') + ".vue'),");
            // }


            routes[0].children.push(
              {
                title: ret.menuListPath[i].List[j].cnName,
                path: props1.url,
                name: ret.menuListPath[i].List[j].id,
                type:props1.component,
                children: [],
                component: resolve => { require([
                  ret.menuListPath[i].id == 5010000 ?
                  '@/components/super/' + props1.component.replace('super/','') + '.vue' :
                    '@/components/unit/' + props1.component.replace('unit/','') + '.vue'
                ], resolve) },
                //component:permissions[ret.menuListPath[i].List[j].id]
              }
            )
          }
        }
      }
      localStorage.setItem("menuRouter", JSON.stringify(routes));//设置缓存
      commit('SET_MENU_ROUTER',routes);
      //获取管理界面的路由
      let manageMenuList = [];
      ret.menuListPath.forEach(item=>{
        if(item.id >= 5050000){
          manageMenuList.push(item)
        }
      })
      getManagePermssion(manageMenuList);
      //如果是机构且是行政区域
      var isOverProvince = false;
      if(ret.user.isEnterprise != '1' && ret.user.divisionLevel != undefined && ret.user.divisionLevel <= 1 ){//省级以上
        isOverProvince = true;
      }

      localStorage.setItem("isOnlyManage", isOnlyManage.toString());
      commit('SET_IS_ONLY_MANAGE',isOnlyManage.toString());

      localStorage.setItem("manageKey", manageKey);
      commit('SET_MANAGE_KEY', manageKey);

      localStorage.setItem("certification", ret.certificate);
      commit('SET_CERTIFICATION', ret.certificate);

      localStorage.setItem("userId", ret.user.userId);
      commit('SET_USER_ID', ret.user.userId);

      localStorage.setItem("name", ret.user.name);
      commit('SET_USER_NAME', ret.user.name);

      localStorage.setItem("userTypeName", ret.user.userTypeName);
      commit('SET_USER_TYPE_NAME', ret.user.userTypeName);

      localStorage.setItem("photo", ret.user.photo);
      commit('SET_PHOTO', ret.user.photo);

      localStorage.setItem("mobile", ret.user.mobile);
      commit('SET_MOBILE', ret.user.mobile);

      localStorage.setItem("agencyId", ret.user.agencyId);
      commit('SET_AGENCY_ID', ret.user.agencyId);

      localStorage.setItem("agencyName", ret.user.agencyName);
      commit('SET_AGENCY_NAME', ret.user.agencyName);

      localStorage.setItem("isLeafAgency", ret.user.isLeafAgency);
      commit('SET_IS_LEAF_AGENCY', ret.user.isLeafAgency);

      localStorage.setItem("agencyTypeId", ret.user.agencyTypeId);
      commit('SET_AGENCY_TYPE_ID', ret.user.agencyTypeId);

      localStorage.setItem("mapLonLat", JSON.stringify(ret.mapLonLat));
      commit('SET_MAP_LON_LAT', JSON.stringify(ret.mapLonLat));

      localStorage.setItem("userAccount", ret.user.userAccount);
      commit('SET_USER_ACCOUNT', ret.user.userAccount);

      // localStorage.setItem("address", JSON.stringify(ret.address));
      // commit('SET_ADDRESS', JSON.stringify(ret.address));
      //角色判断
      var roleTypeList = [];
      for (var i = 0; i < ret.user.roleTypeList.length; i++) {
        //不需要判断是否单位？而且这个字段都没了？
        //if(ret.user.isLeafAgency == 1){//单位的
          roleTypeList.push(ret.user.roleTypeList[i].roleTypeId);
        //}
      }
      localStorage.setItem("roleTypeList", JSON.stringify(roleTypeList));
      commit('SET_ROLE_TYPE_LIST', JSON.stringify(roleTypeList));

      //是否单位管理员
      var isUnitManageMan = 0;
      if(roleTypeList.indexOf(4)> -1 ){
        isUnitManageMan = 1;
      }
      localStorage.setItem("isUnitManageMan", isUnitManageMan);
      commit('SET_IS_UNIT_MANAGE_MAN', isUnitManageMan);

      //标题设置
      var titleUrl = window.location.host;
      var titleData = titleNameJson;
      var titleKey = titleData[titleUrl.split('.',1)];
      if(titleKey == undefined){
        titleKey = '';
      }
      //太原的单位账号登录是 单位名称 + 标题
      let titleName;
      if(titleKey == '山西省' || titleUrl == "17.168.0.99:89" || titleUrl == "183.201.254.54:8096" || titleKey == '太原市'){
        titleName="综合安防管理系统"
      }else if(titleKey == '扬名广场'){
        titleName = titleKey + "隐患巡查系统 ";
      }else if(titleKey == '珠海市机关事务管理局消防安全管理系统'){
        titleName = titleKey;
      }
      else{
        titleName = titleKey + "安消一体化综合应用管理平台";
      }
      if(titleKey == '成都市')
        titleKey = '';
      localStorage.setItem("titleName",titleName.toString());
      commit('SET_TITLE_NAME',titleName.toString());

      localStorage.setItem("urlTitle",titleKey);
      commit('SET_URL_TITLE',titleKey);

      //判断机构/单位
      var isEnterprise = ret.user.isEnterprise;
      localStorage.setItem("isEnterprise",isEnterprise);
      commit('SET_IS_ENTERPRISE',isEnterprise);

      //判断是否是维保单位   isMaintainAgency 1 是 0否
      var isMaintainAgency = ret.user.isMaintainAgency;
      localStorage.setItem("isMaintainAgency",isMaintainAgency);
      commit('SET_IS_MAINTAINAGENCY',isMaintainAgency);
      //机构的行政划分
      var division ={
        divisionId:ret.user.divisionId,
        divisionLevel:ret.user.divisionLevel,
        divisionName:ret.user.divisionName,
        divisionPid:ret.user.divisionPid,
        isOverProvince: ret.user.divisionLevel <=1 && ret.user.divisionLevel != undefined && ret.user.isEnterprise != 1,//是否省级以上
      };
      localStorage.setItem("division",JSON.stringify(division));
      commit('SET_DIVISION',JSON.stringify(division));
      var grid = {
        gridId: ret.user.gridId,
        gridName: ret.user.gridName
      };
      localStorage.setItem("grid",JSON.stringify(grid));
      commit('SET_GRID',grid);

      localStorage.setItem("resetPassword",ret.user.resetPassword);
      commit('SET_RESET_PASSWORD',ret.user.resetPassword);

    }
  }
};

//获取管理界面的路由
function getManagePermssion(permission){
  //将界面权限转换成路由
  let myRouter = [];
  for(let a=0;a<permission.length;a++){
    let props0 = getProps(permission[a].url);

    //打印权限
    // console.log("//" + permission[a].cnName);
    // console.log(  permission[a].id + ":()=>import('@/components/manage/"+ props0.component + ".vue'),");

    myRouter.push(
      {
        title:permission[a].cnName,
        path:props0.url,
        name:permission[a].id,
        component: resolve => {require([ '@/components/manage/' + props0.component + '.vue'], resolve)},
        //component:permissions[permission[a].id],
        children:[],
        meta:{
          id:permission[a].id,
          title:permission[a].cnName,
          icon:permission[a].icon,
          local:props0.component,
        }
      }
    );
    for(let b=0;b<permission[a].List.length;b++){
      let props1 = getProps(permission[a].List[b].url);
      //打印权限
      //console.log(permission[a].List[b].id + ":()=>import('@/components/managePage/"+ props1.component + ".vue'),");

      myRouter[a].children.push(
        {
          title:permission[a].List[b].cnName,
          path:props1.url,
          name:permission[a].List[b].id,
          component: resolve => {require([ '@/components/managePage/' + props1.component + '.vue'], resolve)},
          //component:permissions[permission[a].List[b].id],
          children:[],
          meta:{
            id:permission[a].List[b].id,
            title:permission[a].List[b].cnName,
            icon:permission[a].List[b].icon,
            local:props1.component
          },
          props:props1.props
        }
      );
      for(let c=0;c<permission[a].List[b].List.length;c++){
        let props2 = getProps(permission[a].List[b].List[c].url);
        myRouter[a].children[b].children.push(
          {
            title:permission[a].List[b].List[c].cnName,
            path:props2.url,
            name:permission[a].List[b].List[c].id,
            component: resolve => {require([ '@/components/managePage/' + props2.component + '.vue'], resolve)},
            meta:{
              id:permission[a].List[b].List[c].id,
              title:permission[a].List[b].List[c].cnName,
              icon:permission[a].List[b].List[c].icon,
              local: props2.component,
            },
            props:props2.props
          }
        );
      }
    }
  }
  //更新管理界面的菜单权限
  store.dispatch('GenerateRoutes',myRouter)
}

//将问号后面转成Oject（有些组件需要传入参数）
function getProps(data){
  //url改成用逗号存储组件和url了
  let parameters = data.split(',');
  let component = parameters[0];
  let url = parameters[1];
  var resultMap={
    haveProps: false,
    props:{},
    url:url,
    component:component
  };
  if(url !=undefined && url.indexOf('?') > -1){
    var result = {};
    var querys = url.substring(url.indexOf('?') + 1).split('&');
    for(var i = 0; i < querys.length; i++) {
      var temp = querys[i].split('=');
      if(temp.length < 2) {
        result[temp[0]] = '';
      } else {
        result[temp[0]] = temp[1];
      }
    }
    resultMap={
      haveProps: true,
      props:result,
      component:component,
      url:url.split("?")[0]
    };

  }
  return resultMap;
}
export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js